import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const TaskLvpIcon = createIcon({
    viewBox: '25 25 50 50',
    path: (
        <Path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M52.1928 33.3333C57.278 33.3333 61.4648 36.9873 62.0028 41.6822C65.8468 41.9024 69.0704 44.4385 70.2997 47.9166H29.3858C30.4018 43.162 34.8267 39.5833 40.1314 39.5833C41.0441 39.5833 41.9308 39.6892 42.7785 39.8889C44.0382 36.0889 47.7768 33.3333 52.1928 33.3333ZM47.8655 63.7339H29.1665V67.1323H47.9165L47.8655 63.7339ZM54.1665 63.7339H70.7822L70.8332 67.1323H54.1665V63.7339ZM36.569 57.5856L29.1665 57.5836V60.982H36.567L36.569 57.5856ZM41.6665 57.5836L70.8351 57.5856L70.8331 60.982H41.6665V57.5836ZM29.2175 54.8336H52.4165V51.4352L29.2175 51.4333V54.8336ZM70.8332 54.8336H56.2499V51.4333L70.8332 51.4352V54.8336Z'
            fill='currentColor'
        />
    ),
})

TaskLvpIcon.displayName = 'TaskLvpIcon'
